import {deliveriesService} from "../../../services";
import InputField from "../../input-field";
import React, {useContext, useEffect, useState} from 'react';
import {Button, Col, Modal, notification, Row, Spin} from "antd";
import SelectField from "../../select-field";
import '../modals.css';
import i18n from "i18next";
import {getTranslatedCountries} from "../../../helpers/translate.helpers";
import {AppContext} from "../../../contexts/app-context";

export default function ModalCreateForeignPartner({
                                                    isShow,
                                                    setIsShow,
                                                    setShowAttachDriverOrderDelivery,
                                                    setUpdateForeignPartnerList
                                                  }) {

  const [loading, setLoading] = useState(true);
  const [fieldsErrors, setFieldsErrors] = useState([]);

  const [countryList, setCountryList] = useState([]);
  const [translatedCountryList, setTranslatedCountryList] = useState([]);

  const [country, setCountry] = useState('');
  const [name, setName] = useState('');
  const [city, setCity] = useState('');
  const [street, setStreet] = useState('');
  const [apartment, setApartment] = useState('');
  const [identityNumber, setIdentityNumber] = useState('');
  const [house, setHouse] = useState('');

  let bigButtonStyle = {
    width: '290px',
    height: '75px',
    fontSize: '24px',
    color: 'white',
    backgroundColor: '#1CAA53',
    border: 'none'
  };

  const appContext = useContext(AppContext);

  useEffect(() => {
    setTranslatedCountryList(getTranslatedCountries(countryList));
  },[appContext.lang.lang])

  if (loading) {
    deliveriesService
      .getCountryList()
      .then((response) => {
        setCountryList(response);
        setTranslatedCountryList(getTranslatedCountries(response));
        setLoading(false);
      })
      .catch((error) => {
        setCountryList([]);
        notification.error({
          message: i18n.t('components.notification.titles.getCountryList'),
          description: error,
        });
        setLoading(false);
      });
  }

  const onClickCreateForeignPartner = () => {
    setLoading(true);

    const foreignPartnerData = {
      name: name,
      country: country,
      identityNumber: identityNumber,
      apartment: apartment,
      street: street,
      house: house,
      city: city,
    };

    deliveriesService.createForeignPartner(foreignPartnerData)
      .then((response) => {
        setLoading(false);

        if (response.status === 'success') {
          notification.success({
            message: i18n.t('components.notification.titles.createForeignPartner'),
            description: response.message,
          });

          setIsShow(false);
          setShowAttachDriverOrderDelivery(true);
          setUpdateForeignPartnerList(false);

        } else if (response.status === 'error') {
          setFieldsErrors(response.errors);
        }
      })
      .catch((error) => {
        notification.error({
          message: i18n.t('components.notification.titles.createForeignPartner'),
          description: error,
        });

        setLoading(false);
      });
  };

  const getFieldErrors = (nameField) => {
    return (fieldsErrors && typeof fieldsErrors[nameField] !== "undefined")
      ? fieldsErrors[nameField][0]
      : null;
  };

  return (
    <Modal
      title={<span className="ant-modal-title">{i18n.t('modals.modalCreateForeignPartner.title')}</span>}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => {
        setIsShow(false);
        setShowAttachDriverOrderDelivery(true);
      }}
      footer={[
        <Button htmlType="submit" key="submit" type="primary" style={bigButtonStyle}
                onClick={onClickCreateForeignPartner}>{i18n.t('main.buttons.add')}</Button>,
      ]}
    >
      <Spin spinning={loading} tip={i18n.t('main.loadText.loading')}>
        <Row gutter={16} className="add-padding-10">
          <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 20px 0'}}>
            <InputField
              name="name" label={i18n.t('modals.modalCreateForeignPartner.fields.name.title')}
              value={name} setValue={setName}
              getFieldErrors={getFieldErrors}
            />
          </Col>
          <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 20px 0'}}>
            <SelectField
              title={i18n.t('modals.modalCreateForeignPartner.fields.country.title')}
              name="country"
              selectedValue={country}
              values={translatedCountryList}
              onChange={(value) => {
                setCountry(value);
              }}
              getErrors={getFieldErrors}
              notFoundText={i18n.t('modals.modalCreateForeignPartner.fields.country.notFoundText')}
              style={{width: "100%"}}
            />
          </Col>
          <Col lg={12} md={24} sm={24} xs={24}>
            <InputField
              name="identity_number" label={i18n.t('modals.modalCreateForeignPartner.fields.identityNumber.title')}
              value={identityNumber} setValue={setIdentityNumber}
              getFieldErrors={getFieldErrors}
            />
          </Col>
        </Row>
        <Row gutter={16} className="add-padding-10">
          <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 20px 0'}}>
            <InputField
              name="city" label={i18n.t('modals.modalCreateForeignPartner.fields.city.title')}
              value={city} setValue={setCity}
              getFieldErrors={getFieldErrors}
            />
          </Col>
          <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 20px 0'}}>
            <InputField
              name="street" label={i18n.t('modals.modalCreateForeignPartner.fields.street.title')}
              value={street} setValue={setStreet}
              getFieldErrors={getFieldErrors}
            />
          </Col>
          <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 20px 0'}}>
            <InputField
              name="house" label={i18n.t('modals.modalCreateForeignPartner.fields.house.title')}
              value={house} setValue={setHouse}
              getFieldErrors={getFieldErrors}
            />
          </Col>
          <Col lg={12} md={24} sm={24} xs={24} style={{margin: '0 0 20px 0'}}>
            <InputField
              name="apartment" label={i18n.t('modals.modalCreateForeignPartner.fields.apartment.title')}
              value={apartment} setValue={setApartment}
              getFieldErrors={getFieldErrors}
            />
          </Col>
        </Row>
      </Spin>
    </Modal>
  );
}
